import { useCallback } from "react"
import { logout } from "~/domain/user-session"
import { PopupHint } from "~/shared/ui"
import { Button } from "~/shared/ui/kit"
import { EiosIcon } from "~/shared/ui/icons/EiosIcon"
import cssModule from "~/templates/main/MainUserbar/index.module.scss"
import { useMediaQuery } from "react-responsive"
import { breakPoints } from "~/shared/ui/constants"
import { actionButtonSize } from "~/templates/main/MainUserbar/style"

export function ExitButton() {

	const isSmallDevice = useMediaQuery({ maxWidth: breakPoints.sm })

	const handleLogoutButtonClick = useCallback(async () => {
		await logout()
	}, [])

	return <div>
		<PopupHint position="bottom" text="Выйти">
			<Button
				className="button-without-focus"
				onClick={handleLogoutButtonClick}
				colorStyle="secondary"
				transparent
				borderless
				style={{
					flex: "0 1 auto",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					padding: "0",
					...actionButtonSize
				}}
			>
				<EiosIcon className={cssModule.exitIcon}
						  name="exit"
						  style={{

							  fontSize: isSmallDevice ? "1.45rem" : "1.75rem"
						  }} />
			</Button>
		</PopupHint>
	</div>
}